const map = {
	"./1.png": 3633,
	"./10.png": 4885,
	"./11.jpg": 4680,
	"./12.jpg": 7527,
	"./12.png": 6103,
	"./14.jpg": 7465,
	"./14.png": 9201,
	"./15.jpg": 3116,
	"./16.jpg": 8283,
	"./24.jpg": 512,
	"./25.jpg": 2253,
	"./26.jpg": 4450,
	"./27.jpg": 831,
	"./28.jpg": 3020,
	"./29.jpg": 809,
	"./3.png": 7219,
	"./30.jpg": 2419,
	"./33-removebg-preview.png": 6733,
	"./33.png": 3456,
	"./Certificate/ISO Certificate.jpeg": 4643,
	"./Certificate/isi.png": 4385,
	"./Certificate/iso.png": 5607,
	"./Certificate/trademark.jpeg": 9798,
	"./Plumber Meet/10.jpg": 3602,
	"./Plumber Meet/11.jpg": 5311,
	"./Plumber Meet/6.jpg": 1851,
	"./Plumber Meet/7.jpg": 5390,
	"./Plumber Meet/8.jpg": 4045,
	"./Plumber Meet/9.jpg": 6944,
	"./PoloPipes.png": 2899,
	"./company.jpeg": 8386,
	"./gallery/DSC_0016.JPG": 636,
	"./gallery/DSC_0017.jpg": 9802,
	"./gallery/DSC_0018.JPG": 2562,
	"./gallery/DSC_0019.JPG": 8479,
	"./gallery/DSC_0020.JPG": 3823,
	"./gallery/DSC_0021.JPG": 1922,
	"./gallery/DSC_0033.JPG": 4431,
	"./gallery/DSC_0035 (1).jpg": 4872,
	"./gallery/DSC_0035.JPG": 321,
	"./gallery/DSC_0036.JPG": 294,
	"./gallery/DSC_0046 (1).jpg": 3258,
	"./gallery/DSC_0046.JPG": 7043,
	"./gallery/DSC_0049.JPG": 3336,
	"./gallery/DSC_0058.JPG": 7694,
	"./gallery/DSC_0059.jpg": 5216,
	"./gallery/DSC_0065.JPG": 1642,
	"./gallery/DSC_0067.JPG": 24,
	"./gallery/DSC_0068 (1).jpg": 5134,
	"./gallery/DSC_0068.JPG": 9971,
	"./gallery/DSC_0075.JPG": 7573,
	"./gallery/DSC_0086 (1).jpg": 1278,
	"./gallery/DSC_0086.JPG": 3863,
	"./gallery/DSC_1072.JPG": 1777,
	"./gallery/IMG_20230808_155738 (1).jpg": 892,
	"./gallery/IMG_20230808_155738.jpg": 5106,
	"./gallery/IMG_20230808_155914.jpg": 806,
	"./gallery/IMG_20230808_155929.jpg": 9746,
	"./gallery/IMG_20230808_160141.jpg": 1988,
	"./gallery/IMG_20230808_160157.jpg": 665,
	"./gallery/IMG_20230808_160226.jpg": 1510,
	"./gallery/IMG_20230808_160609.jpg": 8483,
	"./gallery/IMG_20230808_160621.jpg": 3281,
	"./gallery/IMG_20230808_160745.jpg": 4526,
	"./gallery/IMG_20230808_160759.jpg": 5549,
	"./gallery/IMG_20230808_161235.jpg": 4853,
	"./gallery/IMG_20230808_161251.jpg": 2519,
	"./gallery/IMG_20230808_161357 (1).jpg": 6706,
	"./gallery/IMG_20230808_161357.jpg": 1664,
	"./gallery/IMG_20230808_161610.jpg": 6538,
	"./gallery/IMG_20230808_161723.jpg": 993,
	"./gallery/IMG_20230808_161940.jpg": 7278,
	"./gallery/IMG_20230808_162102.jpg": 8661,
	"./gallery/extrusion.jpeg": 7364,
	"./home-space.jpg": 4878,
	"./home_about.jpg": 5033,
	"./lab.png": 6517,
	"./logo.png": 3839,
	"./new logo.jpg": 3233,
	"./newlogo2.png": 2653,
	"./polologo.jpeg": 1044,
	"./products/Casing Pipe.png": 7540,
	"./products/HDPE Pipe.png": 3888,
	"./products/Plumbing & Casing Pipe.png": 182,
	"./products/RS Pipe.png": 1460,
	"./products/SWR Pipe.png": 7035,
	"./products/Solvent Cement.jpeg": 4319,
	"./products/range.jpeg": 1125,
	"./products/uPVC Column Pipe.jpeg": 8372,
	"./products/uPVC Pipe.png": 5621,
	"./safety.png": 4548,
	"./warehouse.png": 977,
	"./we_are.jpg": 8585
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4320;